import { render, staticRenderFns } from "./TipsContent.vue?vue&type=template&id=3b818758&scoped=true"
import script from "./TipsContent.vue?vue&type=script&lang=js"
export * from "./TipsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b818758",
  null
  
)

export default component.exports